import React from "react";

// reactstrap components
import {NavItem, NavLink, Nav, Container, Row, Col} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";

let commonStrings = new LocalizedStrings(common_strings);

const Login = () => {

    localize();
    return (
        <>
            <footer className="py-5" style={{backgroundColor: "#323238"}}>
                <Container>
                    <Row className="align-items-center justify-content-xl-between">
                        <Col xl="6">
                            <div className="copyright text-center text-xl-left text-white">
                                © 2020{" "}
                                <a
                                    className="font-weight-bold ml-1 text-white"
                                    href="https://hello.openmanagerapp.com"
                                    target="_blank"
                                >
                                    OPEN
                                </a>
                            </div>
                        </Col>
                        <Col xl="6">
                            <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                {/*<NavItem>*/}
                                {/*  <NavLink*/}
                                {/*    href="https://www.creative-tim.com?ref=adr-auth-footer"*/}
                                {/*    target="_blank"*/}
                                {/*  >*/}
                                {/*    Creative Tim*/}
                                {/*  </NavLink>*/}
                                {/*</NavItem>*/}
                                <NavItem>
                                    <NavLink
                                        className="text-muted"
                                        href="https://hello.openmanagerapp.com"
                                        //target="_blank"
                                    >
                                        {commonStrings.open.about_open_link}
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className="d-none"
                                        href=""
                                        target="_blank"
                                    >
                                        {commonStrings.open.client_app_link}
                                    </NavLink>
                                </NavItem>
                                {/*<NavItem>*/}
                                {/*  <NavLink*/}
                                {/*    href="https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md?ref=adr-auth-footer"*/}
                                {/*    target="_blank"*/}
                                {/*  >*/}
                                {/*    MIT License*/}
                                {/*  </NavLink>*/}
                                {/*</NavItem>*/}
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
    }
};

export default Login;
